exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".asset-history-table{overflow:auto;max-height:750px}", ""]);

// exports
